<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <b-card class="w-100">
          <b-tabs>
            <b-tab id="tab-left-1" title="รายละเอียดเรื่องแจ้งเบาะแส">
              <ClueDetail 
                :clueData="clueData"
              />
            </b-tab>
            <TabAttachFiles
              @handle-upload="onAttachFileUploaded"
              @handle-delete="onAttachFileDelete"
              :attachFiles="clueData.attachFiles"
              :attachFileDate="clueData.attachFileDates"
              :IsEdit_TabAttachFiles="false"
            />
          </b-tabs>
        </b-card>
      </b-row>
    </b-col>
    <RightTab
      :clueId="this.$route.query.id"
      :clueAction="this.$route.query.clueAction"
      :isClue="true"
      :redirectComponentName="'RequestConfirm'"
      :backComponentName="'ClueAction'"
      :copyComponentName="'ClueActionManage'"
      :IsUse_Tab3="false"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import ClueDetail from "../components/ClueDetail";

import RightTab from "../../components/RightTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";

import * as clueStore from "@/store/api/clue/index.js";
import * as userStore from "@/store/api/user/index.js";

import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    RightTab,
    TabAttachFiles,
    ClueDetail,
  },
  data() {
    return {
      clueData: {
        attachFiles: [],
        attachFileDates: [],
      },
    };
  },
  mounted() {
    this.getClueData();
  },
  methods: {
    getClueData() {
      const _this = this;
      clueStore
        .getById(this.$route.query.id)
        .then((response) => {
          _this.clueData = response.data.data;
          console.log("getClueData", response.data.data);
          // console.log("getClueData", _this.clueData.attachFiles);
          // console.log("getClueData", _this.clueData.attachFileDates);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onAttachFileUploaded(file) {
      const _this = this;
      console.log("onAttachFileUploaded", file);
      _this.clueData.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      console.log("onAttachFileDelete", id, file);
      const file = this.clueData.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      console.log('attachFiles', filteredAry);

      var filteredAry = this.clueData.attachFiles.filter((o) => o.attachId != id);

      this.clueData.attachFiles = filteredAry; 
    },
    // checkboxChanged(obj) {
    //   //console.log("obj", obj);
    //   if (obj.checked) {
    //     this.masterIdList.push(obj.masterId);
    //   } else {
    //     //uncheck
    //     this.masterIdList = this.masterIdList.filter((o) => {
    //       return o != obj.masterId;
    //     });

    //     //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

    //     var notInside = [];
    //     //get remove list
    //     this.complaintDetail.forEach((o) => {
    //       if (obj.masterTypeId < o.masterTypeId) {
    //         o.tmMasterList.forEach((o2) => {
    //           notInside.push(o2.masterId);
    //         });
    //       }
    //     });

    //     //console.log("notInside:", notInside);
    //     this.masterIdList = this.masterIdList.filter((o) => {
    //       return !notInside.includes(o);
    //     });
    //     //end check
    //   }

    //   console.log("masterIdList:", this.masterIdList);

    //   var self = this;

    //   complaintStore
    //     .GetMasterTypeAll(this.masterIdList)
    //     .then(function(response) {
    //       console.log("response:", response);
    //       var dataList = response.data.data; //list รายการทั้งหมด
    //       //self.$refs.Step3Ref.refreshPage()

    //       //แสดงรายการ checkbox
    //       self.complaintDetail.forEach((o) => {
    //         o.tmMasterList = dataList.filter((o2) => {
    //           return o2.masterTypeId == o.masterTypeId;
    //         });
    //       });

    //       //ใส่ค่า check true
    //       self.complaintDetail.forEach((o) => {
    //         o.tmMasterList.forEach((o2) => {
    //           if (self.masterIdList.includes(o2.masterId)) {
    //             o2.checked = true;
    //           }
    //         });
    //       });
    //       self.$refs.Step3Ref.refreshPage();
    //     })
    //     .catch(function(error) {
    //       console.log("error", error);
    //     })
    //     .then(function() {});
    //   //console.log("checkboxChangeRoot: ", obj);
    // },
  },
};
</script>

<style lang="scss"></style>
